module.exports = __webpack_public_path__ + "staticcomp/img/cover.0999a72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/8/cover.jpg
// module id = girg
// module chunks = 39